// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".queryPnl{margin-top:50px}.blockedIPPnl{padding:20px}", ""]);
// Exports
module.exports = exports;
